export const INTERNAL_TOOLS_KEY = 'internalTools';
export const ENABLE_INTERNAL_TOOLS = false;
